import React from "react";
import { motion } from "framer-motion";
import Services from "../components/Services";

const ServicesPage = () => {
  return (
    <>
      <Services />
    </>
  );
};

export default ServicesPage;
